var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Welcome to the dices")]),_vm._v(" "),_c('p',[_vm._v("Right now we are under construction")]),_vm._v(" "),_c('p',[_vm._v("URL: "+_vm._s(_vm.pageconfig.tipo + " - " + _vm.pageconfig.id))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c6f8e6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-dices.vue
// module id = 73
// module chunks = 0